import { useFetchEQLFields } from '@modules/common/hooks';
import { useMemo } from 'react';
import useGetSourceDetailsMap from 'v2/core/repository/edge-server/source-details';
import { apolloStatusToQueryStatus } from 'v2/core/repository/edge-server/statusConvertor';
import {
  AndStatuses,
  UseExecuteEQLInput,
} from 'v2/core/repository/edge-server/types';
import { mapToEQL } from 'v2/core/repository/eql/mappers';

export const useGetEQLExpression = (input: UseExecuteEQLInput) => {
  // TODO: Refactor this. Idealy a gateway should only call one API to avoid
  // any business logic.
  const {
    data: sourceDetailsMap,
    status: sourceDetailStatus,
    error,
  } = useGetSourceDetailsMap();

  const { fields: eqlFields, isLoading: isLoadingEqlFields } =
    useFetchEQLFields();

  const eqlFieldsStatus = apolloStatusToQueryStatus(isLoadingEqlFields, true);
  const status = AndStatuses([eqlFieldsStatus, sourceDetailStatus]);

  return {
    eql: useMemo(
      () =>
        sourceDetailsMap
          ? mapToEQL({
              ...input.eqlProps,
              sourceDetailsMap,
              eqlFields,
            })
          : undefined,
      [eqlFields, input.eqlProps, sourceDetailsMap],
    ),
    status,
    error,
  };
};
